import { Dialog as DialogPrimitive } from "radix-ui";

export const DialogClose = DialogPrimitive.Close;
